import { campaignKey as campaign } from './campaign/key';
import { ordersKey as orders } from './orders/key';
import { customerKey as customer } from './customer/key';
import { marketKey as market } from './market/key';
import { cartKey as cart } from './cart/key';
import { reviewKey as review } from './review/key';

export const keys = {
  campaign,
  orders,
  customer,
  market,
  cart,
  review,
} as const;
